module.exports = __webpack_public_path__ + "img/p2-orange.9cf959a4.png";